import {
  Offer,
  Transaction,
  CashbackBalance,
  LinkedCard,
  Product,
} from '../types'

export const mockOffers: Offer[] = [
  {
    id: '1',
    merchant: 'Joe and Bella',
    category: 'clothing',
    imageUrl:
      'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=800',
    cashbackPercent: 5,
    maxCashback: 50,
    description: 'Adaptive clothing designed for ease of dressing.',
    longDescription:
      'Joe & Bella creates beautiful, functional adaptive apparel that makes dressing easier for older adults and those with mobility challenges. Earn 5% cash back on your first purchase.',
    expiresAt: '2023-12-31',
    terms: [
      'Online only',
      'First purchase only',
      'Cannot be combined with other codes',
    ],
    rating: 4.8,
    reviewCount: 1234,
    about:
      'Joe & Bella is an adaptive apparel brand for older adults. We make clothes that make getting dressed easier, less painful, and more dignified.',
    benefits: [
      'Free Shipping on Orders $50+',
      'Easy Returns Within 30 Days',
      'Senior-Friendly Design',
    ],
  },
  {
    id: '2',
    merchant: 'Audien Hearing',
    category: 'health',
    imageUrl:
      'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800',
    cashbackPercent: 8,
    maxCashback: 100,
    description: 'Affordable, rechargeable hearing aids.',
    longDescription:
      'Audien Hearing provides high-quality, affordable hearing aids directly to consumers. No prescription required. Improve your hearing today and earn cash back.',
    expiresAt: '2024-01-15',
    terms: ['Valid on Atom and Atom Pro models', 'One use per customer'],
    rating: 4.6,
    reviewCount: 856,
    about:
      'Audien Hearing offers high-quality, rechargeable hearing aids for a fraction of the price of traditional hearing aids. No prescription needed.',
    benefits: ['FDA Registered', 'Rechargeable', 'Crystal Clear Sound'],
  },
  {
    id: '3',
    merchant: 'Silver Cuisine',
    category: 'home',
    imageUrl: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=800',
    cashbackPercent: 10,
    maxCashback: 30,
    description: 'Doctor-designed meal delivery for seniors.',
    longDescription:
      'Delicious, nutritionally balanced meals delivered right to your door. Special diets available including Heart Healthy, Diabetic Friendly, and Low Sodium.',
    expiresAt: '2023-11-30',
    terms: ['New customers only', 'Minimum order $50'],
    rating: 4.7,
    reviewCount: 2100,
    about:
      'Silver Cuisine by bistroMD is a meal delivery service designed specifically for seniors. Enjoy chef-prepared meals delivered to your door.',
    benefits: ['Doctor-Designed', 'No Contracts', 'Specialty Diets Available'],
  },
  {
    id: '4',
    merchant: 'MobileHelp',
    category: 'mobility',
    imageUrl:
      'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800',
    cashbackPercent: 15,
    maxCashback: 75,
    description: 'Medical alert systems for peace of mind.',
    longDescription:
      'Top-rated medical alert systems with GPS tracking and fall detection. Stay safe at home or on the go.',
    expiresAt: '2024-03-01',
    terms: ['Requires 3-month subscription', 'Valid for new activations'],
    rating: 4.9,
    reviewCount: 5432,
    about:
      "MobileHelp is America's premier provider of medical alert systems. We offer peace of mind and independence for seniors and their loved ones.",
    benefits: ['24/7 Monitoring', 'GPS Tracking', 'Fall Detection'],
  },
  {
    id: '5',
    merchant: 'EasyComforts',
    category: 'home',
    imageUrl: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=800',
    cashbackPercent: 4,
    maxCashback: 20,
    description: 'Personal care and home comfort products.',
    longDescription:
      'Find hard-to-find personal care items, health aids, and home comfort solutions designed to make life easier.',
    expiresAt: '2023-12-15',
    terms: ['Online purchases only'],
    rating: 4.5,
    reviewCount: 980,
    about:
      'EasyComforts offers a wide selection of personal care products, health aids, and home solutions to help you live comfortably and independently.',
    benefits: [
      'Hard-to-Find Items',
      'Satisfaction Guaranteed',
      'Affordable Prices',
    ],
  },
]

export const mockProducts: Product[] = [
  // Joe and Bella
  {
    id: 'p1',
    brandId: '1',
    name: 'Magnetic Button Shirt',
    price: 45.0,
    rating: 4.8,
    imageUrl:
      'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400',
  },
  {
    id: 'p2',
    brandId: '1',
    name: 'Easy-Grip Pants',
    price: 55.0,
    rating: 4.7,
    imageUrl: 'https://images.unsplash.com/photo-1542272617-08f086302542?w=400',
  },
  {
    id: 'p3',
    brandId: '1',
    name: 'Adaptive Shoes',
    price: 89.0,
    rating: 4.9,
    imageUrl:
      'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=400',
  },

  // Audien Hearing
  {
    id: 'p4',
    brandId: '2',
    name: 'Atom Pro Hearing Aid',
    price: 249.0,
    rating: 4.6,
    imageUrl:
      'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=400',
  },
  {
    id: 'p5',
    brandId: '2',
    name: 'Atom Hearing Aid',
    price: 99.0,
    rating: 4.5,
    imageUrl:
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400',
  },

  // Silver Cuisine
  {
    id: 'p6',
    brandId: '3',
    name: 'Heart Healthy Meal Pack',
    price: 129.0,
    rating: 4.8,
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
  },
  {
    id: 'p7',
    brandId: '3',
    name: 'Diabetic Friendly Meals',
    price: 135.0,
    rating: 4.7,
    imageUrl:
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400',
  },

  // MobileHelp
  {
    id: 'p8',
    brandId: '4',
    name: 'Classic Medical Alert',
    price: 19.95,
    rating: 4.9,
    imageUrl:
      'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400',
  },
  {
    id: 'p9',
    brandId: '4',
    name: 'Mobile Duo System',
    price: 44.95,
    rating: 4.8,
    imageUrl:
      'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=400',
  },

  // EasyComforts
  {
    id: 'p10',
    brandId: '5',
    name: 'Ergonomic Jar Opener',
    price: 12.99,
    rating: 4.5,
    imageUrl:
      'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=400',
  },
  {
    id: 'p11',
    brandId: '5',
    name: 'Non-Slip Bath Mat',
    price: 24.99,
    rating: 4.6,
    imageUrl:
      'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400',
  },
]

export const mockTransactions: Transaction[] = [
  {
    id: 't1',
    merchant: 'Joe and Bella',
    amount: 120.0,
    cashback: 6.0,
    status: 'earned',
    date: '2023-10-15',
    cardId: 'card1',
  },
  {
    id: 't2',
    merchant: 'CVS Pharmacy',
    amount: 45.5,
    cashback: 1.36,
    status: 'pending',
    date: '2023-10-28',
    cardId: 'card2',
  },
  {
    id: 't3',
    merchant: 'Silver Cuisine',
    amount: 85.0,
    cashback: 8.5,
    status: 'earned',
    date: '2023-09-20',
    cardId: 'card1',
  },
  {
    id: 't4',
    merchant: 'Audien Hearing',
    amount: 99.0,
    cashback: 7.92,
    status: 'pending',
    date: '2023-10-30',
    cardId: 'card2',
  },
  {
    id: 't5',
    merchant: 'Walgreens',
    amount: 25.0,
    cashback: 0.75,
    status: 'earned',
    date: '2023-09-15',
    cardId: 'card1',
  },
]

export const mockBalance: CashbackBalance = {
  total: 24.53,
  available: 15.25,
  pending: 9.28,
}

export const mockLinkedCards: LinkedCard[] = [
  {
    id: 'card1',
    brand: 'visa',
    last4: '1234',
    expiryMonth: 12,
    expiryYear: 2025,
    isActive: true,
    addedDate: '2023-06-15',
    nickname: 'Primary Card',
  },
  {
    id: 'card2',
    brand: 'mastercard',
    last4: '5678',
    expiryMonth: 8,
    expiryYear: 2024,
    isActive: true,
    addedDate: '2023-08-22',
    nickname: 'Backup Card',
  },
  {
    id: 'card3',
    brand: 'amex',
    last4: '9012',
    expiryMonth: 3,
    expiryYear: 2023,
    isActive: false,
    addedDate: '2022-01-10',
    nickname: 'Old Card',
  },
]
